import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import AddEditCategories from "../components/category/addEditCategory/addEditCategories";
import CategoryList from "../components/category/categoryList";
import Product from "../components/category/addEditCategory/product";
import { forSlideFromLeftAnimation } from "../shared/hooks/funcions";

const CategoryStack = () => {
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"CategoryList"}
            screenOptions={{ headerShown: false, cardStyleInterpolator: forSlideFromLeftAnimation }}>
            <AppStack.Screen name="CategoryList" component={CategoryList} />
            <AppStack.Screen name="AddEditCategories" component={AddEditCategories} />
            <AppStack.Screen name="CategoryProducts" component={Product} />
        </AppStack.Navigator>
    );
};

export default CategoryStack;